<template>
  <v-text-field
    v-if="!enabled"
    :value="selected?.name"
    :label="$t('categories.template.name')"
    dense
    outlined
    disabled
  />
  <v-select
    v-else
    v-model="selected"
    :disabled="!enabled"
    :items="items"
    :loading="loading"
    :rules="rules"
    item-text="name"
    item-value="id"
    :label="$t('categories.template.name')"
    dense
    outlined
  />
</template>

<script>
import { TemplateService } from "@/services/documents"
import { STATE_ENUM } from "@/utils/consts"

export default {
  name: "TemplateSelect",
  props: {
    companyId: {
      type: Number
    },
    enabled: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      items: [],
      loading: false
    }
  },
  computed: {
    selected: {
      get: function () {
        return this.value ? Object.assign({}, this.value) : null
      },
      set: function (newId) {
        const newValue = this.items.find(e => e.id === newId)
        this.$emit("input", newValue)
      }
    }
  },
  methods: {
    async fetchItems(companyId = 0) {
      this.loading = true
      const kwargs =
        companyId > 0
          ? { state: STATE_ENUM.PUBLISHED.id, company: companyId }
          : { state: STATE_ENUM.PUBLISHED.id }
      this.items = await TemplateService.getAll(companyId, kwargs)
      this.loading = false
    }
  },
  watch: {
    companyId: {
      immediate: true,
      handler(newValue, oldValue) {
        this.fetchItems(newValue)
      }
    }
  }
}
</script>
